import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      backgroundColor: 'var(--x-bg-1)',
      borderRadius: 16,
      padding: [16, 24],

      '&:hover': {
        cursor: 'pointer',
        boxShadow: '0px 4px 16px var(--x-shadow-card)',
      },
    },
    link: {
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      justifyContent: 'space-between',
    },

    textContainer: {
      alignItems: 'center',
      display: 'flex',
    },

    text: {
      color: 'var(--x-text-color-1)',
      fontSize: 16,
      fontWeight: 600,
      lineHeight: '24px',
      marginLeft: 12,
    },
  },
  { name: 'SameCategoryCard' },
);

export default useStyles;
